import styled from '@emotion/styled'

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  .title {
    color: #364a63;
  }
  .description {
    margin-top: 8px;
  }
`

export default StyledContent
